define("auth/models/ig-preview-post", ["exports", "@ember/debug", "rsvp", "@ember/utils", "@ember/object"], function (_exports, _debug, _rsvp, _utils, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _object.default.extend({
    socialProfile: null,
    gram: null,
    mediaItem: null,
    igPost: null,
    scheduledTime: null,
    newScheduledTime: null,
    isRemoved: false,
    originalQueueOrder: null,
    queueOrder: null,
    autoSchedulingId: (0, _object.computed)('isIgPost', 'isNew', 'mediaItem.id', 'isCurrentlyScheduled', 'gram.id', function () {
      if (this.isIgPost) {
        return null;
      } else if (this.isNew) {
        return 'media_item::' + this.get('mediaItem.id');
      } else if (this.isCurrentlyScheduled) {
        return 'gram::' + this.get('gram.id');
      }

      return null;
    }),
    originalScheduledTime: (0, _object.computed)('isIgPost', 'igPost.createdTime', 'isNew', 'newScheduledTime', 'isCurrentlyScheduled', 'gram.scheduledTime', function () {
      if (this.isIgPost) {
        return this.get('igPost.createdTime');
      } else if (this.isNew) {
        return this.newScheduledTime;
      } else if (this.isCurrentlyScheduled) {
        return this.get('gram.scheduledTime');
      }

      return null;
    }),
    description: (0, _object.computed)('isIgPost', 'isNew', 'newScheduledTime', 'isCurrentlyScheduled', 'gram.scheduledTime', function () {
      if (this.isIgPost) {
        return '';
      } else if (this.isNew) {
        return this.get('mediaItem.defaultCaption');
      } else if (this.isCurrentlyScheduled) {
        return this.get('gram.caption');
      }

      return null;
    }),
    imageUrl: (0, _object.computed)('isIgPost', 'igPost', 'igPost.secureThumbUrl', 'isNew', 'mediaItem', 'mediaItem.medThumbnailOrProcessingUrl', 'isCurrentlyScheduled', 'gram', 'gram.medThumbnailOrMediaMedThumbnail', function () {
      if (this.isIgPost) {
        return this.get('igPost.secureThumbUrl');
      } else if (this.isNew) {
        return this.get('mediaItem.medThumbnailOrProcessingUrl');
      } else if (this.isCurrentlyScheduled) {
        return this.get('gram.medThumbnailOrMediaMedThumbnail');
      }

      return '';
    }),
    shouldShowVideoIcon: (0, _object.computed)('isCarousel', 'isVideo', function () {
      return !this.isCarouselPost && this.isVideo;
    }),
    mediaIcon: (0, _object.computed)('igPost.isIGTV', function () {
      var _this$igPost;

      return (_this$igPost = this.igPost) !== null && _this$igPost !== void 0 && _this$igPost.isIGTV ? 'igtv' : 'video';
    }),
    scheduledMoment: (0, _object.computed)('scheduledTime', function () {
      if ((0, _utils.isNone)(this.scheduledTime)) {
        return null;
      }

      return moment(this.scheduledTime * 1000);
    }),
    hasScheduledTime: (0, _object.computed)('scheduledTime', function () {
      return !(0, _utils.isNone)(this.scheduledTime);
    }),
    secureImageUrl: (0, _object.computed)('imageUrl', function () {
      if (!(0, _utils.isEmpty)(this.imageUrl)) {
        return this.imageUrl.replace('http://', 'https://');
      }

      return null;
    }),
    isVideo: (0, _object.computed)('mediaItem.isVideo', 'igPost.isVideo', 'gram.isVideo', function () {
      return !this.isReelsPost && (this.get('mediaItem.isVideo') || this.get('igPost.isVideo') || this.get('gram.isVideo'));
    }),
    isCarouselPost: (0, _object.computed)('igPost.isCarouselPost', 'gram.isCarouselPost', function () {
      return this.get('igPost.isCarouselPost') || this.get('gram.isCarouselPost');
    }),
    isReelsPost: (0, _object.computed)('igPost.isReels', 'gram.isInstagramReel', function () {
      return this.get('igPost.isReels') || this.get('gram.isInstagramReel');
    }),
    hasUpdatedScheduledTime: (0, _object.computed)('originalScheduledTime', 'scheduledTime', function () {
      if (this.isIgPost) {
        return false;
      }

      return this.originalScheduledTime !== this.scheduledTime;
    }),
    hasUpdatedQueueOrder: (0, _object.computed)('originalQueueOrder', 'queueOrder', function () {
      if (this.isIgPost) {
        return false;
      }

      return this.originalQueueOrder !== this.queueOrder;
    }),
    hasBeenEdited: (0, _object.computed)('isIgPost', 'hasUpdatedScheduledTime', 'hasUpdatedQueueOrder', 'isNew', 'isRemoved', function () {
      if (this.isIgPost) {
        return false;
      }

      return this.hasUpdatedScheduledTime || this.hasUpdatedQueueOrder || this.isRemoved || this.isNew;
    }),
    canMove: (0, _object.computed)('isNew', 'isCurrentlyScheduled', function () {
      return this.isNew || this.isCurrentlyScheduled;
    }),
    canDelete: (0, _object.computed)('isNew', 'isCurrentlyScheduled', 'gram.isSaving', function () {
      return this.isNew || this.isCurrentlyScheduled && !this.get('gram.isSaving');
    }),
    canEdit: (0, _object.computed)('canMove', 'canDelete', function () {
      return this.canMove || this.canDelete;
    }),
    isIgPost: (0, _object.computed)('igPost', function () {
      return !(0, _utils.isNone)(this.igPost);
    }),
    isCurrentlyScheduled: (0, _object.computed)('gram', function () {
      return !(0, _utils.isNone)(this.gram);
    }),
    isNew: (0, _object.computed)('mediaItem', function () {
      return !(0, _utils.isNone)(this.mediaItem);
    }),
    cssHandle: (0, _object.computed)('isIgPost', 'isNew', 'isCurrentlyScheduled', function () {
      if (this.isIgPost) {
        return 'e--post__ig';
      } else if (this.isNew) {
        return 'e--post__new';
      } else if (this.isCurrentlyScheduled) {
        return 'e--post__scheduled';
      }

      return '';
    }),
    editedCssClass: (0, _object.computed)('isNew', 'isRemoved', 'hasUpdatedScheduledTime', 'hasUpdatedQueueOrder', 'hasBeenEdited', function () {
      if (this.isNew) {
        return 'has--changes';
      } else if (this.isRemoved) {
        return 'has--changes';
      } else if (this.hasUpdatedScheduledTime) {
        return 'has--changes';
      } else if (this.hasUpdatedQueueOrder) {
        return 'has--changes';
      } else if (this.hasBeenEdited) {
        return 'has--changes';
      }

      return '';
    }),

    remove() {
      if (this.isCurrentlyScheduled) {
        this.set('isRemoved', true);
      }
    },

    persist() {
      const self = this;
      return new _rsvp.Promise((resolve, reject) => {
        if (self.get('isCurrentlyScheduled')) {
          const gram = self.get('gram');

          if (self.get('isRemoved')) {
            gram.destroyRecord().then(() => {
              resolve();
            }, reason => {
              reject(reason);
            });
          } else {
            gram.set('scheduledTime', self.get('scheduledTime'));
            gram.save().then(() => {
              resolve();
            }, reason => {
              reject(reason);
            });
          }
        } else if (self.get('isNew')) {
          (0, _debug.debug)('== persisting : ' + self.get('id'));
          resolve();
        }
      });
    },

    reset() {
      if (this.isCurrentlyScheduled) {
        this.set('scheduledTime', this.originalScheduledTime);
        this.set('isRemoved', false);
        this.set('queueOrder', this.originalQueueOrder);
      } else if (this.isNew) {
        this.set('scheduledTime', this.newScheduledTime);
        this.set('queueOrder', this.originalQueueOrder);
      }
    }

  });

  _exports.default = _default;
});